export const items =  [
    {
      id: 1,
      category: 'mobiles',
      title: "Apple iPhone 14",
      imgSrc: 'https://m.media-amazon.com/images/I/71xb2xkN5qL._SL1500_.jpg',
      amazonLink: 'https://amzn.to/3PuckZp',
      description: 'Apple iPhone 14 (128 GB) - Blue',
      price: '89999',
    },
    {
      id: 5,
      category: 'laptops',
      title: "Xiaomi [Smartchoice] Notebookpro",
      imgSrc: 'https://m.media-amazon.com/images/I/71TPda7cwUL._SL1500_.jpg',
      amazonLink: 'https://amzn.to/3EzeQaC',
      description: 'Xiaomi [Smartchoice] Notebookpro ',
      price: '49999',
    },
    {
      id: 7,
      category: 'tablets',
      title: "Xiaomi Pad 6",
      imgSrc: 'https://m.media-amazon.com/images/I/51b9LjzmPCL._SL1080_.jpg',
      amazonLink: 'https://amzn.to/3ZeNRdY',
      description: 'Xiaomi Pad 6| Qualcomm Snapdragon 870| ',
      price: '29999',
    },
    {
      id: 2,
      category: 'mobiles',
      title: "Apple iPhone 11",
      imgSrc: 'https://m.media-amazon.com/images/I/71xb2xkN5qL._SL1500_.jpg',
      amazonLink: 'https://amzn.to/44MiYi6',
      description: 'Apple iPhone 11 (64GB) - White',
      price: '79999',
    },
    {
      id: 6,
      category: 'tablets',
      title: "Lenovo Tab P12 Pro AMOLED",
      imgSrc: 'https://m.media-amazon.com/images/I/51b9LjzmPCL._SL1080_.jpg',
      amazonLink: 'https://amzn.to/3RabsdH',
      description: 'Lenovo Tab P12 Pro AMOLED (12.6 inch (32 cm), 8 GB, 256 GB, Wi-fi Only), Storm Grey with Precision Pen 3',
      price: '19999',
    },
    {
      id: 3,
      category: 'mobiles',
      title: "Apple iPhone 13",
      imgSrc: 'https://m.media-amazon.com/images/I/71xb2xkN5qL._SL1500_.jpg',
      amazonLink: 'https://amzn.to/3r6XJtv',
      description: 'Apple iPhone 13 (128GB) - Blue',
      price: '69999',
    },
    {
      id: 4,
      category: 'laptops',
      title: "Lenovo IdeaPad Slim 5 ",
      imgSrc: 'https://m.media-amazon.com/images/I/71TPda7cwUL._SL1500_.jpg',
      amazonLink: 'https://amzn.to/44JsK4r',
      description: 'Lenovo IdeaPad Slim 5 Intel Core i5 12450H 14" (35.5cm) ',
      price: '29999',
    },
    {
      id: 9,
      category: 'tablets',
      title: "Samsung Galaxy Tab A8",
      imgSrc: 'https://m.media-amazon.com/images/I/51b9LjzmPCL._SL1080_.jpg',
      amazonLink: 'https://amzn.to/3Pdsh4F',
      description: 'Samsung Galaxy Tab A8 26.69cm (10.5 inch) Display, RAM 4 GB, ROM 64 GB Expandable, Wi-Fi Tablet, Gray, (SM-X200NZAEINU)',
      price: '49999',
    },
    {
      id: 8,
      category: 'laptops',
      title: "Apple MacBook Air Laptop",
      imgSrc: 'https://m.media-amazon.com/images/I/71TPda7cwUL._SL1500_.jpg',
      amazonLink: 'https://amzn.to/3r9rvhm',
      description: 'Apple MacBook Air Laptop M1 chip, 13.3-inch/33.74 cm Retina Display, ',
      price: '89999',
    },


  ]